import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import Messages from '../components/messages';
import Logger from '../components/logger';
import fetchWithCSRF from '../helper/fetch-with-csrf';

MessageBroker.subscribe(Messages.ELEMENT.HIDDEN, (event) => {
    const elementNode = event.element;
    const cookieBarUrl = elementNode.getAttribute('jsh-cookie-bar');

    if(cookieBarUrl) {
        fetchWithCSRF(cookieBarUrl, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        })
            .then((response) => {
                if(response.ok) {
                    return Logger.debug(`POST successful, response: ${JSON.stringify(response)}`);
                }
                return Logger.debug(`POST error: ${JSON.stringify(response)}`);
            });
    }
});
